import { render, staticRenderFns } from "./Abstracts.vue?vue&type=template&id=5425f02a&scoped=true&"
import script from "./Abstracts.vue?vue&type=script&lang=js&"
export * from "./Abstracts.vue?vue&type=script&lang=js&"
import style0 from "./Abstracts.vue?vue&type=style&index=0&id=5425f02a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5425f02a",
  null
  
)

export default component.exports